export default __webpack_public_path__ + "static/media/bruxismo_4.adfbf7e8.jpg";